import { Middleware } from '@reduxjs/toolkit';

import {
  choosePaymentMethod,
  fetchPaymentCurrentStateSuccess,
  fetchPaymentInfoStart,
  processPaymentSuccess,
  setActiveScreen,
} from '@cashier/cashier-data-access';
import {
  DynamicScreens,
  PaymentActionResult,
  PaymentStateInfo,
  PaymentStates,
} from '@cashier/cashier-model';
import { eventBus, EventFactory } from '@cashier/cashier-shared';

export const communicationTasksMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    const getPaymentNotificationEvent = (
      state: string,
      transactionId: string,
      amount: string,
    ) => {
      switch (state) {
        case PaymentStates.SUCCESSFUL:
          return EventFactory.processingResult(transactionId, state, amount);
        case PaymentStates.FAILED:
          return EventFactory.transactionFailed(transactionId, state, amount);
        case PaymentStates.CANCELLED:
          return EventFactory.transactionCanceled(transactionId, state, amount);
        default:
          return null;
      }
    };

    const notifyAboutPayment = (
      state: string,
      transactionId: string,
      amount: string,
    ): void => {
      const event = getPaymentNotificationEvent(state, transactionId, amount);
      if (event) {
        eventBus.emit(event);
      }
    };

    if (action.type === fetchPaymentCurrentStateSuccess.toString()) {
      const { payload }: { payload: PaymentStateInfo } = action;
      const {
        customerInformation: { activeScreen, amount },
      } = store.getState();

      if (activeScreen !== DynamicScreens.PaymentForm) {
        notifyAboutPayment(payload.state, payload.transactionId, amount);
      }
    }

    if (action.type === processPaymentSuccess.toString()) {
      const result: PaymentActionResult = action.payload;

      const {
        customerInformation: { amount },
      } = store.getState();

      notifyAboutPayment(result.status, result.transactionId, amount);
    }

    if (
      [
        fetchPaymentInfoStart.toString(),
        choosePaymentMethod.toString(),
        setActiveScreen.toString(),
      ].includes(action.type) ||
      action.payload === DynamicScreens.ProcessingResult ||
      action.payload === DynamicScreens.PaymentForm
    ) {
      eventBus.emit(EventFactory.scrollTop());
    }

    return result;
  };
